import React from 'react';

export const Tree = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="79"
      height="74"
      fill="none"
      viewBox="0 0 79 74"
    >
      <path
        fillRule="evenodd"
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M40.136 40.87l-6.737-8.603a3.14 3.14 0 104.5-4.384l-8.866-10.69c3.1 3.08 7.293-1.2 4.21-4.666L23.489 2.153a3.333 3.333 0 00-4.85 0l-9.75 10.38c-3.083 3.46 1.11 7.74 4.207 4.667L4.229 27.883a3.142 3.142 0 104.504 4.384l-6.74 8.603a3.143 3.143 0 002.213 5.367h33.717a3.143 3.143 0 002.213-5.367zM75.263 34.497L67.706 24.37c2.64 2.92 5.793-1.333 3.587-4.41l-7.56-10.157a3.303 3.303 0 00-5.334 0L50.856 19.96c-2.207 3.063.947 7.333 3.59 4.41l-7.56 10.127a3.107 3.107 0 001.56 5.076h25.257a3.107 3.107 0 001.56-5.076z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#163E63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M21.066 46.24v13.333M61.066 39.573v10M1.066 61.153A56.753 56.753 0 0150.9 72.897M37.97 57.123a50.116 50.116 0 0139.763-5.75"
      ></path>
    </svg>
  );
};
